import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { awsHealthMonitorApiRef, AwsHealthMonitorClient } from './api';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

const awsHealthMonitorApi = ApiBlueprint.make({
  params: defineParams => defineParams({
    api: awsHealthMonitorApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new AwsHealthMonitorClient({ discoveryApi, fetchApi }),
  }),
});

const awsHealthMonitorPage = PageBlueprint.make({
  params: {
    path: '/aws-health-monitor',
    title: 'AWS Health',
    icon: <LocalHospitalIcon />,
    loader: () =>
      import('./components/AwsHealthServicePage').then(m => <m.AwsHealthServicePage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'aws-health-monitor',
  extensions: [awsHealthMonitorApi, awsHealthMonitorPage],
});
